import Modal from "@edgetier/modal";
import { FunctionComponent, memo } from "react";
import { IProps } from "./interaction-modal.types";
import { defaultContext as defaultInteractionContext } from "components-for/interactions/interaction-context";
import InteractionModalContent from "components-for/interactions/interaction-modal-content";

/**
 * A modal for displaying an interaction.
 * @param props.areWritingIssuesVisible Are writing issues visible in the interaction messages.
 * @param props.interactionId           The ID of the interaction being viewed.
 * @param props.modalProps              Props needed to render the modal.
 */
const InteractionModal: FunctionComponent<IProps> = ({
    areWritingIssuesVisible = defaultInteractionContext.areWritingIssuesVisible,
    interactionId,
    ...modalProps
}) => {
    return (
        <Modal size="super-wide" {...modalProps}>
            <InteractionModalContent areWritingIssuesVisible={areWritingIssuesVisible} interactionId={interactionId} />
        </Modal>
    );
};

export default memo(InteractionModal);
